module.exports = __webpack_public_path__ + "static/media/partisan-records.6e0c8f8b.png";